var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIcon15(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 4.99746V7.01413C18.3333 8.3308 17.4999 9.16413 16.1833 9.16413H13.3333V3.33913C13.3333 2.41413 14.0916 1.6558 15.0166 1.66413C15.9249 1.67246 16.7583 2.03913 17.3583 2.63913C17.9583 3.24746 18.3333 4.0808 18.3333 4.99746Z",
    fill: "#333548",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1.66675 5.83073V17.4974C1.66675 18.1891 2.45008 18.5807 3.00008 18.1641L4.42508 17.0974C4.75841 16.8474 5.22508 16.8807 5.52508 17.1807L6.90841 18.5724C7.23341 18.8974 7.76675 18.8974 8.09175 18.5724L9.49175 17.1724C9.78341 16.8807 10.2501 16.8474 10.5751 17.0974L12.0001 18.1641C12.5501 18.5724 13.3334 18.1807 13.3334 17.4974V3.33073C13.3334 2.41406 14.0834 1.66406 15.0001 1.66406H5.83341H5.00008C2.50008 1.66406 1.66675 3.15573 1.66675 4.9974V5.83073Z",
    fill: "#333548",
    fillOpacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99976 10.2109H7.49976C7.15809 10.2109 6.87476 10.4943 6.87476 10.8359C6.87476 11.1776 7.15809 11.4609 7.49976 11.4609H9.99976C10.3414 11.4609 10.6248 11.1776 10.6248 10.8359C10.6248 10.4943 10.3414 10.2109 9.99976 10.2109Z",
    fill: "#333548",
    fillOpacity: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49976 8.13281H9.99976C10.3414 8.13281 10.6248 7.84948 10.6248 7.50781C10.6248 7.16615 10.3414 6.88281 9.99976 6.88281H7.49976C7.15809 6.88281 6.87476 7.16615 6.87476 7.50781C6.87476 7.84948 7.15809 8.13281 7.49976 8.13281Z",
    fill: "#333548",
    fillOpacity: 0.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97469 6.67188C4.50802 6.67188 4.14136 7.04687 4.14136 7.50521C4.14136 7.96354 4.51636 8.33854 4.97469 8.33854C5.43302 8.33854 5.80802 7.96354 5.80802 7.50521C5.80802 7.04687 5.43302 6.67188 4.97469 6.67188Z",
    fill: "#333548",
    fillOpacity: 0.75
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97445 10.0078C4.50778 10.0078 4.14111 10.3828 4.14111 10.8411C4.14111 11.2995 4.51611 11.6745 4.97445 11.6745C5.43278 11.6745 5.80778 11.2995 5.80778 10.8411C5.80778 10.3828 5.43278 10.0078 4.97445 10.0078Z",
    fill: "#333548",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon15);
export default __webpack_public_path__ + "static/media/menu-icon-15.bdea22ecf6ac3f6e3594d23a0450f071.svg";
export { ForwardRef as ReactComponent };